import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Button,
  Checkbox,
  useBreakpointValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  FormControl,
  FormLabel,
  useDisclosure,
  List,
  ListItem,
} from "@chakra-ui/react";
import { FaEllipsisV, FaEye, FaTrash, FaPen } from "react-icons/fa";
import { fetchVouchers } from "../../../../redux/voucherSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";

const VoucherAssetsTable = ({ lgType = "3", deleteVoucher }) => {
  const dispatch = useDispatch();
  const { vouchers, loading } = useSelector((state) => state.vouchers);

  const [visibleVouchers, setVisibleVouchers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("ledger");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedVoucher, setSelectedVoucher] = useState(null);

  const [voucherDetails, setVoucherDetails] = useState(null);
  const [loadingVoucher, setLoadingVoucher] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false); // New loading state for saving
  const [from, setFrom] = useState(""); // State for "From" input
  const [amount, setAmount] = useState(""); // State for "Amount" input
  const [narration, setNarration] = useState(""); // State for "Narration" input
  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [cmpId, setCmpId] = useState(
    () => sessionStorage.getItem("cmp_id") || 1
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fromId, setFromId] = useState(null); // State for "From" ID
  const [ledgerId, setLedgerId] = useState(null); // State for "Ledger Name" ID
  const [showDropdown, setShowDropdown] = useState(false);
  const [companyData, setCompanyData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  const [add, setAdd] = useState();
  const [email, setEmail] = useState();
  const [narationSuggestions, setNarationSuggestions] = useState([]);
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [place, setPlace] = useState();
  const [tin, setTin] = useState();
  const [phone, setPhone] = useState();

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/voucher/asset/add");
  };

  useEffect(() => {
    dispatch(fetchVouchers(lgType));
  }, [dispatch, lgType]);

  useEffect(() => {
    setVisibleVouchers(vouchers);
  }, [vouchers]);

  const handleAddClick = async (voucher) => {
    setSelectedVoucher(voucher);
    setLoadingVoucher(true);

    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/vouchers/voucher_loadsingle.php`,
        {
          vouch_typ: 3,
          led_id: voucher.Ldg_id,
          cmp_id: sessionStorage.getItem("cmp_id"),
        }
      );
      setVoucherDetails(response.data);
      setFrom(""); // Set default value for "From"
      setAmount(""); // Reset amount
      setNarration(""); // Reset narration
      onOpen();

      setLedgerId(voucher.Ldg_id);
    } catch (error) {
      console.error("Error fetching voucher details:", error);
    } finally {
      setLoadingVoucher(false);
    }
  };

  const handleSave = async () => {
    setLoadingSave(true); // Set loading state for saving
    try {
      const voucherData = {
        vo_typeid: 3, // Assuming 3 is the type ID, adjust as necessary
        voch_no: voucherDetails.voucher_number,
        voch_date: new Date().toISOString().split("T")[0],
        in_benb: ledgerId, // ID for the "From" ledger
        in_looser: fromId, // ID for the "Ledger Name"
        loose_amount: amount, // The amount being saved
        vouch_naration: narration, // The narration for the voucher
        user_id:
          sessionStorage.getItem(
            "user_id"
          ) /* Add user ID here, if available */,
        cmp_id: cmpId, // Company ID from your state
        addres: voucherDetails.address,
      };

      console.log("Submitting data:", voucherData);

      const response = await axios.post(
        `${ACCOUNTS_URL}/vouchers/voucher_save.php`,
        voucherData
      );

      console.log("Voucher saved successfully:", response.data);
      if (response.data.success) {
        // Optionally, you can do something after successful save
      }
      onClose(); // Close modal after saving
    } catch (error) {
      console.error("Error saving voucher:", error);
    } finally {
      setLoadingSave(false); // Reset loading state for saving
    }
  };

  const fetchFromSuggestions = async (text) => {
    console.log(text);

    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/common/ledger_name.php`,
        {
          cmp_id: cmpId,
          fectxt: text,
        }
      );

      if (response.data.status === "success") {
        setFromSuggestions(response.data.data);
        console.log("====================================");
        console.log(response.data.data);
        console.log("====================================");
      } else {
        setFromSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setFromSuggestions([]);
    }
  };

  const fetchNarrationSuggestions = async (text) => {
    console.log(text);

    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/common/load_narration.php`,
        {
          cmp_id: cmpId,
          fectxt: text,
          vouch_type_id: 3,
        }
      );

      if (response.data.success) {
        setNarationSuggestions(response.data.data);
        console.log("====================================");
        console.log(response.data.data);
        console.log("====================================");
      } else {
        setNarationSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setNarationSuggestions([]);
    }
  };

  const filteredVouchers = (visibleVouchers || []).filter((voucher) => {
    if (searchType === "ledger") {
      return voucher.L_name.toLowerCase().startsWith(searchTerm.toLowerCase());
    } else if (searchType === "ledgerGroup") {
      return voucher.led_group_name
        .toLowerCase()
        .startsWith(searchTerm.toLowerCase());
    }
    return true;
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredVouchers.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredVouchers.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (voucher, index) => {
    const serialNumber = indexOfFirstRow + index + 1;
    return (
      <Tr key={voucher.Ldg_id} onClick={() => handleAddClick(voucher)}>
        <Td py="12px" px="8px" w="20px" textAlign="center">
          <Checkbox />
        </Td>
        <Td py="12px" px="8px" w="90px" textAlign="center">
          {serialNumber}
        </Td>
        <Td py="12px" px="20px">
          {voucher.L_name}
        </Td>
        <Td py="12px" px="20px">
          {voucher.led_group_name}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          <Box textAlign="right">{voucher.opening_balance}</Box>
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          <Box textAlign="right">{voucher.closing_balance}</Box>
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          <Box textAlign="center">
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<FaEllipsisV />}
                size="sm"
                bg="transparent"
              />
              <MenuList boxShadow="none">
                <MenuItem
                  icon={<FaPen color="black" style={{ fontSize: "12px" }} />}
                  onClick={() => handleAddClick(voucher)} // Trigger modal on Add click
                >
                  Add
                </MenuItem>
                <MenuItem
                  icon={<FaPen color="blue" style={{ fontSize: "12px" }} />}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => deleteVoucher(voucher.Ldg_id)}
                  icon={<FaTrash color="red" style={{ fontSize: "12px" }} />}
                >
                  Delete
                </MenuItem>
              </MenuList>
            </Menu>
          </Box>
        </Td>
      </Tr>
    );
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setError("User not logged in or user_id not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCompanyDetails = async () => {
        try {
          const response = await fetch(
            `${ACCOUNTS_URL}/settings/company_details.php`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ user_id: userId }),
            }
          );

          const data = await response.json();

          if (data.status === 200) {
            setCompanyData(data.data);
          } else {
            setError("No company found for this user.");
          }
        } catch (err) {
          setError("Error fetching company details.");
        }
      };

      fetchCompanyDetails();
    }
  }, [userId]); // Run when userId is set

  function printVoucher(voucherData) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "-9999px";
    document.body.appendChild(iframe);

    function numberToWords(num) {
      if (num === 0) return "Zero";

      const units = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const teens = [
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "Ten",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const thousands = ["", "Thousand", "Million", "Billion"];

      function chunk(num) {
        const parts = [];
        while (num > 0) {
          parts.push(num % 1000);
          num = Math.floor(num / 1000);
        }
        return parts;
      }

      function chunkToWords(chunk) {
        let result = "";

        if (chunk > 99) {
          result += units[Math.floor(chunk / 100)] + " Hundred ";
          chunk %= 100;
        }
        if (chunk > 10 && chunk < 20) {
          result += teens[chunk - 11] + " ";
        } else {
          if (chunk >= 10) {
            result += tens[Math.floor(chunk / 10)] + " ";
            chunk %= 10;
          }
          if (chunk > 0) {
            result += units[chunk] + " ";
          }
        }
        return result.trim();
      }

      const chunks = chunk(num);
      let word = "";

      for (let i = 0; i < chunks.length; i++) {
        if (chunks[i] > 0) {
          word = chunkToWords(chunks[i]) + " " + thousands[i] + " " + word;
        }
      }

      return word.trim();
    }

    function amountToWords(amount) {
      const integerPart = Math.floor(amount);
      const decimalPart = Math.round((amount - integerPart) * 100);
      let words = numberToWords(integerPart) + " Rupees";
      if (decimalPart > 0) {
        words += " and " + numberToWords(decimalPart) + " Paise";
      }
      return words;
    }

    // Dynamically convert amount to words
    voucherData.vo_amount_words = amountToWords(voucherData.amount || 0);

    // Log for debugging
    console.log(voucherData.vo_amount_words); // Example output: "One Thousand Two Hundred Thirty Four Rupees and Fifty Six Paise"

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`
            <html>
                <head>
                    <style>
                        body { 
                            font-family: Arial, sans-serif; 
                            color: #333; 
                            margin: 0; 
                            padding: 20px; 
                        }
    
                        /* Centered Header Section */
                        .header {
                            text-align: center;
                            margin-bottom: 30px;
                        }
                        .header h2 { 
                            margin: 0; 
                            font-size: 22px; 
                            font-weight: bold; 
                        }
                        .header p {
                            margin: 2px 0; 
                            font-size: 14px; 
                        }
    
                        /* Recipient and Invoice Info */
                        .info-section {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 30px;
                            margin-bottom: 20px;
                            font-size: 14px;
                        }
                        .info-section .left,
                        .info-section .right {
                            width: 50%;
                        }
                        .info-section p {
                            margin: 5px 0;
                        }

                         .info-section .right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* Ensures items start from the top */
    align-items: flex-end; /* Aligns content to the right edge */
    text-align: right; /* Aligns text inside the container to the right */
}

    
                        /* Amount Table */
                        .amount-table {
                            width: 100%; 
                            border-collapse: collapse; 
                            margin-top: 20px; 
                            font-size: 14px;
                        }
                        .amount-table th, .amount-table td { 
                            border: 1px solid #ddd; 
                            padding: 8px; 
                            text-align: left; 
                        }
                        .amount-table th {
                            background-color: #f9f9f9; 
                            font-weight: bold; 
                            text-align: center;
                        }
                        .amount-table td:last-child, .amount-table th:last-child {
                            text-align: right;
                        }
    
                        /* Footer Note */
                        .footer-note {
                            margin-top: 20px; 
                            text-align: center; 
                            font-size: 12px; 
                        }

                        .amount-table tbody tr:first-child td {
                             height: 260px; /* Applies to the first row */
                             vertical-align: top;
                        }

                    </style>
                </head>
                <body>
                    <!-- Centered Header Section -->
                       <div class="header">
    ${
      companyData.Company_Name &&
      companyData.Company_Name.startsWith("No") === false
        ? `<h2>${companyData.Company_Name}</h2>`
        : ""
    }
    ${
      companyData.address && companyData.address.startsWith("No") === false
        ? `<p>${companyData.address}</p>`
        : ""
    }
    ${
      companyData.Tin && companyData.Tin.startsWith("No") === false
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
        : ""
    }
    ${
      companyData.Email_Id && companyData.Email_Id.startsWith("No") === false
        ? `<p>Email: ${companyData.Email_Id}</p>`
        : ""
    }
</div>
    
                    <!-- Recipient and Invoice Info Section -->
                    <div class="info-section">
                         <div class="left">
    <p><strong>Buyer (Bill to):</strong></p>
    ${
      voucherData.to_ledger_name &&
      voucherData.to_ledger_name.startsWith("No") === false
        ? `<p>${voucherData.to_ledger_name}</p>`
        : ""
    }
 
                <p>${add}</p>
  
</div>

                        <div class="right">
                            <p><strong>Date:</strong> ${
                              voucherData.voucher_date.split(" ")[0] || ""
                            }</p>
                            <p><strong>Invoice No:</strong>${
                              voucherData.voucher_number || ""
                            }</p>
                        </div>
                    </div>
    
                    <!-- Amount Table -->
                    <table class="amount-table">
                        <thead>
                            <tr>
                                <th>Sl No.</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>${
                                  voucherData.from_ledger_name || "Description"
                                }</td>
                                <td style="font-weight: bold;"> ${
                                  voucherData.amount || "0.00"
                                }</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="text-align: right;">Total</td>
                                <td style="font-weight: bold;">${
                                  voucherData.amount || "0.00"
                                }</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="text-align: center;">${
                                  voucherData.vo_amount_words
                                }</td>
                            </tr>
                        </tbody>
                    </table>
    
                    <!-- Footer Note -->
                    <div class="footer-note">
                        <p>For ${
                          voucherData.from_ledger_name
                            ? voucherData.from_ledger_name
                            : ""
                        }</p>
                    </div>
                </body>
            </html>
        `);
    iframeDoc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    iframe.remove();
  }
  return (
    <Box p={1} minH="750px" bg="white">
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        className="sb"
        p={3}
      >
        <Flex
          align="center"
          justify={{ base: "space-between", sm: "flex-start" }}
          flexWrap="wrap"
          mb={{ base: 2 }}
        >
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="80px" // Smaller width to fit in one line on mobile
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
            mr={2}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text>Entries</Text>
        </Flex>

        <Flex
          justify={{ base: "center", md: "flex-end" }}
          align="center"
          flexDirection={{ base: "column", md: "row" }}
          width={{ base: "100%", md: "auto" }}
        >
          <Stack
            direction={{ base: "column", sm: "row" }}
            spacing={4}
            mb={{ base: 4, md: 0 }} // Adds margin on mobile
            width={{ base: "100%", md: "auto" }}
          >
            <Select
              value={searchType}
              onChange={(e) => setSearchType(e.target.value)}
              borderColor="#E9EDF4"
              width={{ base: "100%", sm: "150px" }}
            >
              <option value="ledger">Ledger</option>
              <option value="ledgerGroup">Ledger Group</option>
            </Select>
            <Input
              type="text"
              placeholder="Search by name"
              value={searchTerm}
              borderColor="#E9EDF4"
              onChange={(e) => setSearchTerm(e.target.value)}
              width={{ base: "100%", sm: "200px" }}
            />
          </Stack>

          <Button
            onClick={handleClick}
            ml={{ base: 0, md: 4 }}
            backgroundColor="teal"
            color="white"
            width={{ base: "100%", md: "auto" }}
          >
            View All
          </Button>
        </Flex>
      </Flex>

      <div
        style={{ overflowX: "auto" }}
        w={{ base: "367px", md: "100%" }}
        className={styles.Table}
      >
        {loading ? (
          <Spinner size="xl" />
        ) : (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
          >
            <Thead>
              <Tr>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  <Checkbox />
                </Th>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  S. No.
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Particulars
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Ledger Group
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Opening Balance
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Closing Balance
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  <Box textAlign="center">Actions</Box>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((voucher, index) => renderRow(voucher, index))
              ) : (
                <Tr>
                  <Td colSpan={7} textAlign="center">
                    No Vouchers Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        )}
      </div>

      <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {loadingVoucher ? <Spinner /> : "Voucher Details"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Voucher No</FormLabel>
              <Input
                value={voucherDetails ? voucherDetails.voucher_number : ""}
                isReadOnly
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>Voucher Date</FormLabel>
              <Input
                value={
                  voucherDetails ? new Date().toISOString().split("T")[0] : ""
                }
                isReadOnly
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>To</FormLabel>
              <Input
                value={voucherDetails ? voucherDetails.ledger_name : ""}
                isReadOnly
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>From</FormLabel>
              <Input
                value={from}
                onChange={(e) => {
                  setFrom(e.target.value);
                  if (e.target.value.length >= 1) {
                    fetchFromSuggestions(e.target.value);
                    setShowDropdown(true); // Show the dropdown when fetching suggestions
                  } else {
                    setShowDropdown(false); // Hide the dropdown if input is less than 2 characters
                  }
                }}
              />
              {showDropdown && fromSuggestions.length > 0 && (
                <Box
                  border="1px solid #ccc"
                  borderRadius="md"
                  mt={1}
                  maxH="150px"
                  overflowY="auto"
                  bg="white"
                  zIndex={1}
                  position="absolute"
                  // width={{ base: "calc(100% - 16px)", md: "45%" }}
                  w="100%"
                >
                  <List spacing={0}>
                    {fromSuggestions.map((suggestion) => (
                      <ListItem
                        key={suggestion.Ldg_id}
                        p={2}
                        _hover={{
                          backgroundColor: "gray.100",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          console.log("Suggestion selected:", suggestion); // Log the entire suggestion object
                          setFrom(suggestion.L_name); // Set the name
                          console.log("Set From:", suggestion.L_name); // Log the name being set
                          setFromId(suggestion.Ldg_id); // Set the ID
                          console.log("Set FromId:", suggestion.Ldg_id); // Log the ID being set
                          setAdd(suggestion.address); // Set the address
                          console.log("Set Address:", suggestion.address); // Log the address
                          setPlace(suggestion.place); // Set the email
                          setEmail(suggestion.email); // Set the email
                          setTin(suggestion.tin); // Set the email
                          setPhone(suggestion.phno); // Set the email

                          console.log("Set Email:", suggestion.email); // Log the email
                          setShowDropdown(false); // Hide dropdown when a suggestion is selected
                          console.log("Dropdown hidden"); // Confirm dropdown is hidden
                        }}
                      >
                        {suggestion.L_name}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
              {showDropdown && fromSuggestions.length === 0 && (
                <Text p={2}>No suggestions found</Text>
              )}
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Amount</FormLabel>
              <Input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>Narration</FormLabel>
              <Input
                value={narration}
                onChange={(e) => {
                  setNarration(e.target.value);
                  if (e.target.value.length >= 1) {
                    fetchNarrationSuggestions(e.target.value);
                    setShowDropdowns(true); // Show the dropdown when fetching suggestions
                  } else {
                    setShowDropdowns(false); // Hide the dropdown if input is less than 2 characters
                  }
                }}
              />
              {showDropdowns && narationSuggestions.length > 0 && (
                <Box
                  border="1px solid #ccc"
                  borderRadius="md"
                  mt={1}
                  maxH="150px"
                  overflowY="auto"
                  bg="white"
                  zIndex={1}
                  position="absolute"
                  // width={{ base: "calc(100% - 16px)", md: "45%" }}
                  w="100%"
                >
                  <List spacing={0}>
                    {narationSuggestions.map((suggestion) => (
                      <ListItem
                        key={suggestion.v_naretion}
                        p={2}
                        _hover={{
                          backgroundColor: "gray.100",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          console.log("Suggestion selected:", suggestion); // Log the entire suggestion object
                          setNarration(suggestion.v_naretion); // Set the name
                          console.log("Set From:", suggestion.v_naretion); // Log the name being set
                          setShowDropdowns(false);
                        }}
                      >
                        {suggestion.v_naretion}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
              {showDropdowns && fromSuggestions.length === 0 && (
                <Text p={2}>No suggestions found</Text>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              onClick={handleSave}
              isLoading={loadingSave}
            >
              Save
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => {
                handleSave();
                printVoucher({
                  voucher_number: voucherDetails?.voucher_number,
                  voucher_date: new Date().toISOString().split("T")[0],
                  from_ledger_name: from,
                  to_ledger_name: voucherDetails?.ledger_name,
                  amount: amount,
                  narration: narration,
                });
              }}
              isLoading={loadingSave}
            >
              Save & Print
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default VoucherAssetsTable;
